import { render, staticRenderFns } from "./DeleteWebsitePanel.vue?vue&type=template&id=55c23399&scoped=true&"
import script from "./DeleteWebsitePanel.vue?vue&type=script&lang=ts&"
export * from "./DeleteWebsitePanel.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteWebsitePanel.vue?vue&type=style&index=0&id=55c23399&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c23399",
  null
  
)

export default component.exports